import { FC } from 'react';
import { ExpensesList } from 'containers/expenses';

const ExpensesPage: FC = () => {
  return <ExpensesList />;
};

export default ExpensesPage;
